module.exports = __webpack_public_path__ + "img/modal_illust01.089ae2fb.png";